export default __webpack_public_path__ + "static/media/cta.63a2c84a.png";